import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ChatCardData } from "../interfaces/Message";

export interface messagingState {
  selectedChatId?: string | null;
  selectedReceiverData?: ChatCardData | null;
  tabIndexId: number;
  notificationBadge: boolean;
  messageBadge: boolean;
}

const initialState: messagingState = {
  tabIndexId: 1,
  notificationBadge: true,
  messageBadge: true,
};

export const messagingSlice = createSlice({
  name: "messagingSlice",
  initialState,
  reducers: {
    setNotificationTab: (state, action: PayloadAction<number>) => {
      state.tabIndexId = action.payload;
    },
    setNotificationBadge: (state, action: PayloadAction<boolean>) => {
      state.notificationBadge = action.payload;
    },
    setMessageBadge: (state, action: PayloadAction<boolean>) => {
      state.messageBadge = action.payload;
    },
    setSelectedChatId: (state, action: PayloadAction<string | null>) => {
      state.selectedChatId = action.payload;
    },
    setSelectedReceiverData: (
      state,
      action: PayloadAction<ChatCardData | null>
    ) => {
      state.selectedReceiverData = action.payload;
    },
    resetMessageState: () => initialState,
  },
});

export const {
  setSelectedChatId,
  setSelectedReceiverData,
  setNotificationTab,
  setMessageBadge,
  setNotificationBadge,
  resetMessageState,
} = messagingSlice.actions;

export default messagingSlice.reducer;
